import { Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import "./ProductDetails.css";
import CurrencySymbol from "../common/CurrencySymbol/CurrencySymbol";
//import { StyledButton } from "../common/StyledComponents/StyledButton/StyledButton";

import { StyledTooltip } from "../common/StyledComponents/StyledTooltip/StyledTooltip";

import { getColorFromCoordinates } from "src/utils/utils";
type Props = {
  productData: any;
  imageUrl: string;
};

const ProductDescription: React.FC<Props> = ({ productData, imageUrl }) => {
  const [bgColorCord, setBgColorCord] = useState<string>("");

  const [imgUrl, setImgUrl] = useState<string>("");

  const imgRef = useRef<HTMLImageElement>(null);

  const getImageUrl = (url: any) => {
    const raw = url;

    const cleaned =
      typeof raw === "string" ? raw.replace(/^['\[]+|['\]]+$/g, "") : "";
    setImgUrl(cleaned);
  };

  // useEffect to trigger on imgUrl change
  useEffect(() => {
    getImageUrl(imageUrl);
    const img = imgRef.current;

    if (!img || !img.complete) return;

    const handleColorPick = () => {
      const x = Math.floor(img.naturalWidth * 0.2);
      const y = Math.floor(img.naturalHeight * 0.8);
      const picked = getColorFromCoordinates(
        img,
        { x, y },
        10,
        productData?.product_color
      );
      if (picked) {
        setBgColorCord(picked);
      }
    };

    handleColorPick();
  }, [imageUrl, bgColorCord, imgUrl, productData]);

  /*   useEffect(() => {
    console.log("BG Color", bgColorCord);
    if (bgColorCord) {
      const hex = bgColorCord;

      const hexColor = hex || productData?.product_color; // Orange
      const names = namer(hexColor);
      console.log("color Name", names, names.basic[0].name); // e.g. "orange"
    }

    const match = getClosestColorMatchFromNamer(productColor, pickedRGB);

    if (match) {
      console.log("Best Match:", match.matchedName);
      console.log("Hex Value:", match.hex);
      console.log("Similarity Score:", match.similarity);
    }
  }, [bgColorCord, productData]); */

  return (
    <div className="product-details">
      <img
        ref={imgRef}
        src={imgUrl}
        alt={productData.title}
        crossOrigin="anonymous"
        onLoad={() => {
          // This is required to trigger re-render and pick color when img loads
          if (imgRef.current?.complete) {
            const x = Math.floor(imgRef.current.naturalWidth * 0.2);
            const y = Math.floor(imgRef.current.naturalHeight * 0.8);
            const picked = getColorFromCoordinates(
              imgRef.current,
              { x, y },
              10,
              productData?.product_color
            );
            if (picked) {
              console.log("Picked Color (onLoad fallback):", picked);
              setBgColorCord(picked);
            }
          }
        }}
        style={{ display: "none" }}
      />

      {productData?.product_title && (
        <Typography
          variant="h1"
          id={`product_${productData.product_title}`}
          className={"product-title"}
        >
          {productData.product_title}
        </Typography>
      )}

      {imageUrl && (
        <Typography
          id={`product_color_${productData.id}`}
          className={"product-description-title"}
        >
          <div id="color-options" className="product-color">
            Color:{" "}
            {bgColorCord && (
              <StyledTooltip
                title={productData?.product_color}
                placement="right-end"
              >
                <div
                  className="color-option"
                  style={{ backgroundColor: bgColorCord }}
                  key={`color-${productData?.product_color}`}
                  /*  title={productData?.product_color} // Tooltip on hover */
                ></div>
              </StyledTooltip>
            )}
            {/* {productData?.product_color} */}
          </div>
        </Typography>
      )}
      {productData?.product_memory && (
        <Typography className="product-description-title">
          Memory: {productData.product_memory}
        </Typography>
      )}

      {productData?.product_storage && (
        <Typography className="product-description-title">
          Storage: {productData.product_storage}
        </Typography>
      )}

      {productData?.product_price && (
        <div className="div-flex-space">
          <Typography
            id={`product_${productData.product_price}`}
            className={"product-price-des"}
            sx={{ textAlign: "left" }}
          >
            <CurrencySymbol
              currencyCode="INR"
              amount={productData.product_price}
            />
          </Typography>
          <img
            loading="lazy"
            alt="retailer icon"
            src={productData?.retailer_logo}
            className="retailer-img"
            onClick={() => window.open(productData?.product_url, "_blank")}
          />
        </div>
      )}

      {productData?.product_description && (
        <>
          <Typography className="product-description-title">
            Description:
          </Typography>
          <Typography
            id={`product_description_${productData.id}`}
            className={"product-description"}
          >
            {productData.product_description}
          </Typography>
        </>
      )}
      <>
        {/* 
      <StyledButton
        type="submit"
        style={{ width: "80%", alignSelf: "center" }}
        sx={{ mt: 3, mb: 2 }}
      >
        Add to wishList
      </StyledButton>
      <StyledButton
        type="submit"
        style={{ width: "80%", alignSelf: "center" }}
        sx={{ mt: 3, mb: 2 }}
      >
        Add to cart
      </StyledButton> */}
      </>
    </div>
  );
};

export default ProductDescription;
